var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('HeaderBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'Category',
        to: {
          name: 'category'
        }
      }, {
        label: 'Add New'
      }],
      "title": "New Category"
    }
  }), _c('div', {
    staticClass: "bg-white w-full rounded-lg my-3 px-4 py-2.5"
  }, [_c('h4', {
    staticClass: "font-bold text-xl py-2.5"
  }, [_vm._v("Create New Category")]), _c('div', {
    staticClass: "w-1/2 flex-col"
  }, [_c('div', [_c('label', {
    staticClass: "block"
  }, [_vm._v("Category Name")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.name,
      expression: "name"
    }],
    staticClass: "px-4 py-2.5 border font-medium text-gray-500 text-sm rounded-lg w-full",
    class: [_vm.submitted && !_vm.name ? 'bg-red-300 focus:ring-red-500 border-red-500 placeholder-red-500' : 'border-gray-300 bg-gray-50 '],
    attrs: {
      "type": "text",
      "id": "name",
      "placeholder": "Enter Display Name"
    },
    domProps: {
      "value": _vm.name
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value;
      }
    }
  }), _vm.submitted && !_vm.name ? _c('p', {
    staticClass: "text-red-500 text-sm mt-1 mb-0"
  }, [_vm._v("Must be filled.")]) : _vm._e()]), _c('div', {
    staticClass: "mt-2"
  }, [_c('label', {
    staticClass: "block"
  }, [_vm._v("Content’s Type")]), _c('SelectType', {
    staticClass: "text-gray-500 font-medium",
    attrs: {
      "isError": _vm.validateItemType,
      "options": _vm.options,
      "defaultText": 'Select Content’s Type'
    },
    model: {
      value: _vm.item_type,
      callback: function ($$v) {
        _vm.item_type = $$v;
      },
      expression: "item_type"
    }
  }), _vm.submitted && !_vm.item_type ? _c('p', {
    staticClass: "text-red-500 text-sm mt-1 mb-0"
  }, [_vm._v("Must be filled.")]) : _vm._e()], 1), _c('div', {
    staticClass: "mt-2 mr-2"
  }, [_c('label', {
    staticClass: "block"
  }, [_vm._v("Category BISAC")]), _c('multiselect', {
    staticClass: "custom-multiselect text-gray-500 text-sm",
    class: {
      'error': _vm.submitted && !_vm.category_bisac
    },
    attrs: {
      "label": "name",
      "track-by": "code",
      "placeholder": "Select Category BISAC",
      "open-direction": "bottom",
      "options": _vm.items_category_bisac,
      "searchable": true,
      "loading": _vm.isLoadingSearch,
      "close-on-select": true
    },
    on: {
      "search-change": _vm.asyncFind
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function (_ref) {
        var option = _ref.option;
        return [_c('div', {
          staticClass: "text-sm"
        }, [_vm._v(" " + _vm._s(option.name) + " ")])];
      }
    }, {
      key: "singleLabel",
      fn: function (_ref2) {
        var option = _ref2.option;
        return [_c('div', {
          staticClass: "text-sm font-medium text-gray-500 px-2"
        }, [_vm._v(" " + _vm._s(option.name) + " ")])];
      }
    }, {
      key: "caret",
      fn: function () {
        return [_c('svg', {
          staticClass: "w-5 h-5 text-gray-500 absolute right-5 top-2.5",
          attrs: {
            "fill": "none",
            "stroke": "currentColor",
            "stroke-width": "2",
            "viewBox": "0 0 24 24"
          }
        }, [_c('path', {
          attrs: {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "d": "M19 9l-7 7-7-7"
          }
        })])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.category_bisac,
      callback: function ($$v) {
        _vm.category_bisac = $$v;
      },
      expression: "category_bisac"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v(" Oops! No elements found. Consider changing the search query. ")])]), _vm.submitted && !_vm.category_bisac ? _c('p', {
    staticClass: "text-red-500 text-sm mt-1 mb-0"
  }, [_vm._v("Must be filled.")]) : _vm._e()], 1), _c('div', {
    staticClass: "mt-2 mr-2"
  }, [_c('label', {
    staticClass: "block"
  }, [_vm._v(" Category AX")]), _c('multiselect', {
    staticClass: "custom-multiselect",
    class: {
      'error': _vm.submitted && !_vm.category_ax
    },
    attrs: {
      "label": "name",
      "track-by": "code",
      "placeholder": "Select Category AX",
      "open-direction": "bottom",
      "options": _vm.axSearchOptions,
      "searchable": true,
      "loading": _vm.isAxSearch,
      "close-on-select": true,
      "multiple": false
    },
    on: {
      "search-change": _vm.axFind
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function (_ref3) {
        var option = _ref3.option;
        return [_c('div', {
          staticClass: "text-sm"
        }, [_vm._v(" " + _vm._s(option.name) + " ")])];
      }
    }, {
      key: "singleLabel",
      fn: function (_ref4) {
        var option = _ref4.option;
        return [_c('div', {
          staticClass: "text-sm font-medium text-gray-500"
        }, [_vm._v(" " + _vm._s(option.name) + " ")])];
      }
    }, {
      key: "caret",
      fn: function () {
        return [_c('svg', {
          staticClass: "w-5 h-5 text-gray-500 absolute right-5 top-2.5",
          attrs: {
            "fill": "none",
            "stroke": "currentColor",
            "stroke-width": "2",
            "viewBox": "0 0 24 24"
          }
        }, [_c('path', {
          attrs: {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "d": "M19 9l-7 7-7-7"
          }
        })])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.category_ax,
      callback: function ($$v) {
        _vm.category_ax = $$v;
      },
      expression: "category_ax"
    }
  }), _vm.submitted && !_vm.category_ax ? _c('p', {
    staticClass: "text-red-500 text-sm mt-1 mb-0"
  }, [_vm._v("Must be filled.")]) : _vm._e()], 1), _c('div', {
    staticClass: "mt-3 mb-4"
  }, [_c('t-checkbox', {
    attrs: {
      "type": "checkbox",
      "id": "is_active"
    },
    model: {
      value: _vm.is_active,
      callback: function ($$v) {
        _vm.is_active = $$v;
      },
      expression: "is_active"
    }
  }), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "is_active"
    }
  }, [_vm._v("Active")])], 1), _c('div', {
    staticClass: "flex justify-start pb-3"
  }, [_c('button', {
    staticClass: "bg-blue-700 text-white rounded-lg px-3 py-2",
    on: {
      "click": _vm.addCategory
    }
  }, [_vm._v("Save")]), _c('button', {
    staticClass: "bg-white text-gray-500 rounded-lg border px-3 py-2 ml-4",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }